import React, {Component} from "react";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import {connect} from "react-redux"

import Login from "../containers/login/login";
import Scaffold from "../containers/scaffold/scaffold";
import PrivateRoute from "../components/private-route/private-route";

import {getUserFromToken} from "../../modules/user";
import {Helmet} from "react-helmet";
import {withWhiteLabelContext} from 'react-whitelabel';
import JoinLiveSession from "../containers/join-live-session/join-live-session.js";

import "font-awesome/css/font-awesome.css"
import "react-toastify/dist/ReactToastify.css";

class App extends Component {
    constructor(props) {    
        super(props);

        this.state = {
            title: "",
            info: "",
            userId: ""
        }
    }

    componentWillMount() {        
        if (process.env.REACT_APP_PLATFORM_REDIRECT_URL) {
            window.location = process.env.REACT_APP_PLATFORM_REDIRECT_URL;
            return;
        }
        const {user} = this.props;
        if (user && user.token && !user.current_user_id) {
            this.props.dispatch(getUserFromToken());
        }
    }

    componentDidUpdate() {
        const {currentUserId, title, info, user} = this.props;
        const {userId} = this.state;

        if (title !== this.state.title || (info && info !== this.state.info)) {
            this.setState({title, info});
        }

        if (currentUserId !== userId) {
            if (currentUserId == null && user.token) {
                this.props.dispatch(getUserFromToken());
            }
            this.setState({userId: currentUserId})
        }
    }

    render() {
        const {user, label} = this.props;
        const {title, info} = this.state;

        return (
            <div className="text-center">
                <Helmet>
                        <title>{label.appTitle}</title>
                        <link rel="shortcut icon" src={label.faveIcon} />
                </Helmet>
                <Router>
                    <Switch>
                        <Route exact path="/together" component={JoinLiveSession}/> 
                        <Route exact path="/login" component={Login}/>                   
                        <PrivateRoute path="/" user={user} component={Scaffold} title={title} info={info}/>
                    </Switch>
                </Router>
            </div>
        );
    }
}

const withState = connect(state => {
    const {pages, user} = state;
    return {
        user,
        currentUserId: user.currentUserId,
        title: pages.title,
        info: pages.info
    };
});

export default withWhiteLabelContext(withState(App));



// WEBPACK FOOTER //
// ./src/components/app/app.js